import type { AxiosResponse } from 'axios';

import { request } from '../requestService';

import { type IConfigDataType } from '../../store/configs/slices';

const ENDPOINTS = {
  config: 'config/',
  validationConfig: 'validation-config',
};

export function getConfigs(): Promise<AxiosResponse<IConfigDataType>> {
  return request({
    url: ENDPOINTS.config,
  });
}

export function getValidationConfig(): Promise<AxiosResponse> {
  return request({
    url: `${ENDPOINTS.config}${ENDPOINTS.validationConfig}`,
  });
}
